/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n,r){return`${n}_${r}`}export{n as createTileObjectId};
